import React from 'react'

import { SvgWrapper } from './SvgWrapper/SvgWrapper'

export const SmokingActiveSvg = ({ size = 24 }: { size?: number }) => (
  <SvgWrapper size={size}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.93636 22.887C6.93636 22.887 12.8277 23.1061 15.2739 17.7154C17.7201 12.3247 17.7201 5.54921 22.9415 4.96712V3.94688C22.9415 3.94688 17.8032 3.29123 14.3771 13.7815C14.3771 13.7815 13.8024 15.7069 12.13 16.5656C11.4289 16.927 10.5667 16.3945 10.5667 15.6525V11.2405C10.5667 10.2251 9.67342 9.40152 8.57409 9.40152H2.99263C1.89158 9.40152 1 10.2251 1 11.2405V18.0129C1 20.7058 3.36312 22.887 6.27676 22.887H6.93636Z"
      fill="url(#paint0_linear-smoking)"
    />
    <path
      d="M4.98935 0.998672H11.0174C12.0883 0.998672 12.9681 1.92117 12.9681 3.05181C12.9681 4.18069 12.0883 5.10495 11.0174 5.10495H8.34105C8.34105 5.10495 5.60774 4.72396 5.60774 7.98006"
      stroke="url(#paint1_linear-smoking)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.85572 0.99867H1.14162"
      stroke="#E2F1F5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear-smoking"
        x1="-0.661314"
        y1="22.1747"
        x2="27.6514"
        y2="22.1747"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EB8E51" />
        <stop offset="1" stopColor="#DA4B23" />
      </linearGradient>
      <linearGradient
        id="paint1_linear-smoking"
        x1="-2.47134"
        y1="0.96329"
        x2="-0.0379942"
        y2="11.5738"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EAF4F6" />
        <stop offset="1" stopColor="#C3E7F1" />
      </linearGradient>
    </defs>
  </SvgWrapper>
)
